import {
  ContentModerationRating,
  ExploreWorkflowItem,
  RecipeTaskStatus,
  WorkflowItem as WorkflowItemType,
} from "@/api/sdk"
import { useState } from "react"
import { BaseImageInViewProps, ImageInViewBase } from "@/components/shared/ImageInViewBase"
import WorkflowPlaceholder from "./WorkflowPlaceholder"
import WorkflowImage from "./WorkflowImage"

interface WorkflowImageInViewProps extends BaseImageInViewProps {
  workflow: WorkflowItemType | (ExploreWorkflowItem & { status?: RecipeTaskStatus })
  hiddenReaction?: boolean
  isShow?: boolean
}

const WorkflowImageInView = ({ workflow, hiddenMenu, hiddenReaction, ...props }: WorkflowImageInViewProps) => {
  const [imageLoaded, setImageLoaded] = useState(false)
  const { image } = workflow
  const [isShow, setIsShow] = useState(
    image?.moderationRating === ContentModerationRating.HardcoreNsfw ||
      image?.moderationRating === ContentModerationRating.SemiNsfw,
  )

  return (
    <ImageInViewBase
      {...props}
      imageDimensions={{
        width: image?.width,
        height: image?.height,
      }}
      moderationRating={image?.moderationRating}
      gaEventData={{
        id: workflow.id,
        name: workflow.name ?? "",
        tab_name: "workflow",
      }}
      isShow={isShow && props.isExplore}
      setIsShow={setIsShow}
    >
      {/* Workflow specific rendering logic */}
      {workflow.status !== RecipeTaskStatus.COMPLETED ? (
        <WorkflowPlaceholder stretch={props.stretch} />
      ) : (
        <WorkflowImage
          image={{
            url: image?.url,
            width: image?.width,
            height: image?.height,
            moderationRating: image?.moderationRating,
          }}
          isShow={props.isExplore && isShow}
          imageLoaded={imageLoaded}
          setImageLoaded={setImageLoaded}
          workflow={workflow}
        />
      )}

      {/* Action buttons and other UI elements */}
    </ImageInViewBase>
  )
}

export default WorkflowImageInView
